import { validateCoordinates } from "~/utility/location/validateCoordinates";
import { LocationService } from "../location.service";
import { mapGeoResponse } from "~/utility/location/location.mapper";

export const setLocationByCoordinatesHandler = async (
    lat: number,
    lng: number,
) => {
    // 1. Validate
    const { isValid, error } = validateCoordinates(lat, lng);
    if (!isValid) {
        return { success: false, message: error };
    }

    try {
        // 2. API Call
        const { data, error: apiError } =
            await LocationService.reverseGeocode({ lat, lng });

        if (apiError) {
            return { success: false, message: apiError };
        }

        const location = data?.[0];
        if (!location) {
            return {
                success: false,
                message: "No address found for the selected location.",
            };
        }

        const cityName = location?.city?.trim();

        if (!cityName) {
            return {
                success: false,
                message: "City not available for this location.",
            };
        }

        let enrichedLocation = {
            ...location, city: {
                name: cityName,
                code: null,
            },
        };

        try {
            const { data: cityData } =
                await LocationService.searchCities(cityName);

            if (cityData?.length) {
                enrichedLocation = {
                    ...location,
                    city: {
                        name: cityName,
                        code: cityData[0]?.code ?? null,
                    },
                };
            }
        } catch (cityErr) {
            console.log("City fetch failed:", cityErr);
        }

        // 3. Map
        const mapped = await mapGeoResponse(enrichedLocation, 'FROM_COORDINATES');

        return {
            success: true,
            message: "Location updated successfully.",
            data: mapped,
        };
    } catch (err) {
        console.error("setLocationByCoordinatesHandler", err);

        return {
            success: false,
            error: err,
            message: "Failed to fetch location. Please try again.",
        };
    }
};